import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { TreeDeciduous, ArrowLeft, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DatenschutzPage = () => {
  const { t, language } = useLanguage();

  const content = {
    de: {
      title: 'Datenschutzerklärung',
      intro: 'Der Schutz Ihrer persönlichen Daten ist uns wichtig. Nachfolgend informieren wir Sie über die Erhebung und Verwendung Ihrer Daten.',
      sections: [
        {
          title: '1. Verantwortliche Stelle',
          content: 'HODEMA edertools AB\nKontakt: info@hodema.se'
        },
        {
          title: '2. Erhebung und Verarbeitung von Daten',
          content: 'Wir erheben personenbezogene Daten, wenn Sie sich registrieren, ein Projekt erstellen oder ein Angebot abgeben. Diese Daten umfassen Name, E-Mail-Adresse und projektbezogene Informationen.'
        },
        {
          title: '3. Zweck der Datenverarbeitung',
          content: 'Ihre Daten werden ausschließlich zur Bereitstellung unserer Dienste verwendet. Wir versenden keine Werbe-E-Mails oder Spam.'
        },
        {
          title: '4. Ihre Rechte',
          content: 'Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer Daten. Kontaktieren Sie uns unter info@hodema.se.'
        }
      ]
    },
    en: {
      title: 'Privacy Policy',
      intro: 'Protecting your personal data is important to us. Below we inform you about the collection and use of your data.',
      sections: [
        {
          title: '1. Responsible Party',
          content: 'HODEMA edertools AB\nContact: info@hodema.se'
        },
        {
          title: '2. Collection and Processing of Data',
          content: 'We collect personal data when you register, create a project or submit an offer. This data includes name, email address and project-related information.'
        },
        {
          title: '3. Purpose of Data Processing',
          content: 'Your data is used exclusively to provide our services. We do not send promotional emails or spam.'
        },
        {
          title: '4. Your Rights',
          content: 'You have the right to access, correction, deletion and restriction of processing of your data. Contact us at info@hodema.se.'
        }
      ]
    },
    se: {
      title: 'Integritetspolicy',
      intro: 'Att skydda dina personuppgifter är viktigt för oss. Nedan informerar vi dig om insamling och användning av dina uppgifter.',
      sections: [
        {
          title: '1. Ansvarig part',
          content: 'HODEMA edertools AB\nKontakt: info@hodema.se'
        },
        {
          title: '2. Insamling och behandling av data',
          content: 'Vi samlar in personuppgifter när du registrerar dig, skapar ett projekt eller lämnar en offert. Dessa uppgifter inkluderar namn, e-postadress och projektrelaterad information.'
        },
        {
          title: '3. Syfte med databehandling',
          content: 'Dina uppgifter används uteslutande för att tillhandahålla våra tjänster. Vi skickar inga reklammejl eller skräppost.'
        },
        {
          title: '4. Dina rättigheter',
          content: 'Du har rätt till tillgång, rättelse, radering och begränsning av behandlingen av dina uppgifter. Kontakta oss på info@hodema.se.'
        }
      ]
    }
  };

  const c = content[language] || content.de;

  return (
    <div className="min-h-screen bg-warm-50">
      <header className="bg-white border-b border-warm-200">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="p-2 rounded-lg bg-primary">
              <TreeDeciduous className="h-5 w-5 text-white" />
            </div>
            <span className="font-serif text-xl font-bold text-primary">ForestHub</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-primary hover:underline mb-8">
          <ArrowLeft className="h-4 w-4" />
          {t('common.back')}
        </Link>

        <h1 className="font-serif text-3xl font-bold text-gray-900 mb-4">{c.title}</h1>
        <p className="text-gray-600 mb-8">{c.intro}</p>

        <div className="space-y-8">
          {c.sections.map((section, index) => (
            <div key={index}>
              <h2 className="font-semibold text-xl text-gray-900 mb-3">{section.title}</h2>
              <p className="text-gray-600 whitespace-pre-line">{section.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-primary/5 rounded-xl border border-primary/20">
          <h3 className="font-semibold text-gray-900 mb-2">{t('landing.contact')}</h3>
          <a href="mailto:info@hodema.se" className="flex items-center gap-2 text-primary hover:underline">
            <Mail className="h-4 w-4" />
            info@hodema.se
          </a>
        </div>
      </main>
    </div>
  );
};

export default DatenschutzPage;
